export default __webpack_public_path__ + "static/media/711.176baa94.gif";